<div class="viewport-1" id="keyPress" (keyup)="keyPress($event)" tabindex="0"
  [style.background-image]="'url(' + interventionTaskService.taskBackgroundImage() + ')'">
  <student-header></student-header>
  <task-bar #taskBar [totalPoints]="taskTotalPoints"></task-bar>
  <div class="task-screen-element spelling-container"
    [style.background-image]="' ' + interventionTaskService.taskContainerColor() + ' '"
    [class]="(animationComplete || !animateContainer) ? 'taskShow' : 'taskHide'">
    <div class="testType font-18">{{interventionTaskService.testType()}}</div>
    <div class="timer-bar-container">
      <trial-timer-bar></trial-timer-bar>
      <button class="replayVideo-no-timerbar" (click)="focusThenReplayVideo()" [disabled]="disableAVButtons"></button>
    </div>
    <div class="spelling-main-container">
      <div class="spelling-image-container" [hidden]="!currentWordImage">
        @if (currentWordImage) {
          <img
            [src]="currentWordImage"
            [alt]="'Image for word'"
            class="spelling-word-image"
            (error)="currentWordImage = null">
        }
      </div>
      <div class="spelling-target-area">
        <div class="audio-controls-container find-the-syllables-speaker-position">
          <button class="speaker" (click)="playTargetAudioViaSpeakerClick()" [disabled]="disableAVButtons"></button>
          <button class="snail-button" (click)="playTargetAudioViaSpeakerClickSlowed()" [disabled]="disableAVButtons"></button>
        </div>
        <div class="spelling-help-row">
          @if (!showType) {
            <button class="spelling-letter-audio-hidden"></button>
          }
          @for (syllable of syllables; track syllable) {
            <button class="spelling-letter-audio"
            [hidden]="!showType" (click)="playSyllableAudio($index)" [disabled]="disableAVButtons"></button>
          }
        </div>
        <div class="spelling-target-row">
          <div class="spelling-target-highlight" [style.width]="' ' + ((targetWord.length) * 6) + '% '" [class.placeholder]="!targetWord.length"></div>
          @if (!targetWord.length) {
            <div class="spelling-target-text font-30">&nbsp;</div>
          } @else {
            @for (letter of targetWord; track $index) {
              <div class="spelling-target-block"
                [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '">
                <div class="spelling-target-text font-30">
                  {{letter}}
                </div>
              </div>
            }
          }
        </div>
        <div class="spelling-help-row">
          @if (!showType) {
            <div class="spelling-letter-space-hidden font-24">_</div>
          }
          @for (letter of targetAnswer; track $index) {
            <div [hidden]="!showType" class="spelling-letter-space font-24">
              <div>
                {{letter.blank}}
              </div>
            </div>
          }
        </div>
        <div class="spelling-help-row">
          @if (!showType) {
            <div class="letter-type-hidden font-24">X</div>
          }
          @for (letter of targetAnswer; track $index) {
            <button class="font-24" [hidden]="!showType"
              [class]="{'vowel' : (letter.cvc === 'V'), 'consonant' : (letter.cvc === 'C'), 'spelling-letter-space' : (letter.cvc !== 'C' && letter.cvc !== 'V')}"
              (click)="seeLetter($index)">
              {{letter.cvc}}
            </button>
          }
        </div>

      </div>
    </div>
    <div [class]="{'keyboard-container': startTask, 'keyboard-container-hidden' : !startTask}">
      <div class="keyboard-row">
        @for (letter of topKeyRow; track letter.text) {
          <button [class]="{'hover': letter.highlight, 'keyboard-key' : startTask, 'keyboard-key-hidden' : !startTask}"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            (click)="addLetter(letter.index)"
            (touchstart)="addHoverClass(letter)"
            (touchend)="handleTouchEndNormalKey(letter.index, $event)"
            [disabled]="disableResponseButtons"
            >
            <div [class]="{'keyboard-letters font-30' : startTask, 'keyboard-letters-hidden' : !startTask}">
              {{letter.text}}
            </div>
          </button>
        }
        <button
          [class]="{'hover': delete.highlight, 'keyboard-delete' : startTask, 'keyboard-delete-hidden' : !startTask}"
          (click)="removeLetter()"
          [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
          (touchend)="handleTouchEndSpecialKey(delete.keyCode, $event)"
          (mouseenter)="addHoverClass(delete)" (mouseleave)="removeHoverClass(delete)"
          [disabled]="disableResponseButtons">
          <div [class]="{'special-text right' : startTask, 'keyboard-letters-hidden' : !startTask}">
            {{delete.text}}
          </div>
        </button>
      </div>
      <div class="keyboard-row">
        @for (letter of middleKeyRow; track letter.text) {
          <button [class]="{'hover': letter.highlight, 'keyboard-key' : startTask, 'keyboard-key-hidden' : !startTask}"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            (click)="addLetter(letter.index)"
            (touchstart)="addHoverClass(letter)"
            (touchend)="handleTouchEndNormalKey(letter.index, $event)"
            [disabled]="disableResponseButtons"
            >
            <div [class]="{'keyboard-letters font-30' : startTask, 'keyboard-letters-hidden' : !startTask}">
              {{letter.text}}
            </div>
          </button>
        }
        <button [class]="{'hover': enter.highlight && targetWord.length !== 0, 'keyboard-enter' : startTask, 'keyboard-enter-hidden' : !startTask, 'keyboard-enter-disabled' : targetWord.length === 0}"
          [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
          (click)="submitResponse(); removeHoverClass(enter)"
          (mouseenter)="addHoverClass(enter)" (mouseleave)="removeHoverClass(enter)"
          (touchstart)="addHoverClass(enter)"
          (touchend)="handleTouchEndSpecialKey(enter.keyCode, $event)"
          [disabled]="disableResponseButtons || targetWord.length === 0">
          <div [class]="{'special-text right' : startTask, 'keyboard-letters-hidden' : !startTask}">
            {{enter.text}}
          </div>
        </button>
      </div>
      <div class="keyboard-row">
        <button
          [class]="{
            'hover': shift.highlight,
            'keyboard-shift' : startTask,
            'keyboard-shift-hidden' : !startTask,
            'caps-lock-on': capsLockOn
          }"
          (click)="shiftLetters()"
          [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
          (mouseenter)="addHoverClass(shift)" (mouseleave)="removeHoverClass(shift)"
          (touchend)="handleTouchEndSpecialKey(shift.keyCode, $event)"
          [disabled]="disableResponseButtons">
          <div [class]="{'special-text' : startTask, 'keyboard-letters-hidden' : !startTask}">
            {{shift.text}}
          </div>
        </button>
        @for (letter of bottomKeyRow; track letter.text) {
          <button [class]="{'hover': letter.highlight, 'keyboard-key' : startTask, 'keyboard-key-hidden' : !startTask}"
            [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
            (click)="addLetter(letter.index);"
            (touchend)="handleTouchEndNormalKey(letter.index, $event)"
            [disabled]="disableResponseButtons"
            >
            <div [class]="{'keyboard-letters font-30' : startTask, 'keyboard-letters-hidden' : !startTask}">
              {{letter.text}}
            </div>
          </button>
        }
        <button
          [class]="{
            'hover': shift.highlight,
            'keyboard-shift' : startTask,
            'keyboard-shift-hidden' : !startTask,
            'caps-lock-on': capsLockOn
          }"
          (click)="shiftLetters()"
          [style.border-color]="' ' + interventionTaskService.highlightColor() + ' '"
          (mouseenter)="addHoverClass(shift)" (mouseleave)="removeHoverClass(shift)"
          (touchend)="handleTouchEndSpecialKey(shift.keyCode, $event)"
          [disabled]="disableResponseButtons">
          <div [class]="{'special-text right' : startTask, 'keyboard-letters-hidden' : !startTask}">
            {{shift.text}}
          </div>
        </button>
        <div class="spelling-empty-keyboard-space"></div>
      </div>
    </div>
  </div>
  @if (isDevMode) {
    <div>{{wordListAttempt}} - {{task.wordlistType}}</div>
  }

  <trial-counter [showCorrectIncorrect]="true" [taskAnimationComplete]="animationComplete"></trial-counter>
  <instructions [videoSource]="instructionalVideoFile"></instructions>
  <save-data-dialog (onSaveButtonClick)="saveTaskData()"></save-data-dialog>
  <focus-dialog></focus-dialog>
  @if (showCapsWarningDialog) {
    <div>
      <div class="caps-warning-opacity-layer"></div>
      <div class="caps-warning-dialog-background">
        <div class="caps-warning-dialog-window">
          <div class="caps-warning-dialog-text">
            You typed the word in
            all capital letters:
            <div class="caps-warning-current-response-text">
              {{capsWarningResponse}}
            </div>
            Do you want to continue?
          </div>
          <div class="caps-warning-dialog-button-container">
            <button class="caps-warning-dialog-cancel-button" [disabled]="capsButtonsDisabled" (click)="hideCapsWarningDialog()"></button>
            <button class="caps-warning-dialog-ok-button" [disabled]="capsButtonsDisabled" (click)="submitResponse()"></button>
          </div>
        </div>
      </div>
    </div>
  }
</div>
